import { LoadSessionsParams, Session } from "../../shared/models/session";
import EnrouteApiClient from "../../shared/services/enroute-api-client";
import { mapAxiosResponse } from "../../shared/utils/api-utils";
import { ServerError, ServerErrorMessages } from "../../shared/utils/server-error-utils";

export default class SessionsService {

  public static async getSessions(orgID: number, params: LoadSessionsParams): Promise<Session[] | Error> {
    return EnrouteApiClient.get(`/org/${ orgID }/sessions`, {
      params: {
        operations: true,
        operation_type: 'target',
        sort_by: 'order',
        sort_mode: 'desc',
        tasks: true,
        tasks_feedback: true,
        ...params
      },
    })
      .then(resp => mapAxiosResponse<Session[]>(resp))
      .catch(error => {
        let errorMessage = ServerErrorMessages[error.message];
        if (!errorMessage) {
          errorMessage = ServerErrorMessages[ServerError.UnexpectedError];
        }

        throw new Error(errorMessage);
      });
  }

}